import { render, staticRenderFns } from "./PubTos.vue?vue&type=template&id=33397bf3&scoped=true&"
import script from "./PubTos.vue?vue&type=script&lang=js&"
export * from "./PubTos.vue?vue&type=script&lang=js&"
import style0 from "./PubTos.vue?vue&type=style&index=0&id=33397bf3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33397bf3",
  null
  
)

export default component.exports